module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_5.706f99ea.png";